import { Controller } from 'stimulus';
import { FetchRequest } from '@rails/request.js';

export default class extends Controller {
  static values = { url: String };

  async destroy(event) {
    event.preventDefault();

    if (!window.confirm('Are you sure?')) {
      return;
    }

    const request = new FetchRequest('delete', this.urlValue);
    const response = await request.perform();

    if (response.redirected) {
      window.location.assign(response.response.url);
    }
  }
}
